import { render, staticRenderFns } from "./booking.vue?vue&type=template&id=11122132&scoped=true&"
import script from "./booking.vue?vue&type=script&lang=js&"
export * from "./booking.vue?vue&type=script&lang=js&"
import style0 from "./booking.vue?vue&type=style&index=0&id=11122132&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11122132",
  null
  
)

export default component.exports